import { Component, Injectable, Input } from "@angular/core";
import "./vehiclePlotTime.component.scss";

@Component({
    selector: "vehicle-plot-time",
    template: require("./vehiclePlotTime.component.html")
})
@Injectable()
export class VehiclePlotTimeComponent {
    @Input() moment: moment.Moment;

    // ---

    constructor() {
    }
}
